import { render, staticRenderFns } from "./AdditionalAssessments.vue?vue&type=template&id=3a454b80"
import script from "./AdditionalAssessments.vue?vue&type=script&lang=js"
export * from "./AdditionalAssessments.vue?vue&type=script&lang=js"
import style0 from "./AdditionalAssessments.vue?vue&type=style&index=0&id=3a454b80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports